// components/brand/BrandForm/BasicInfo.js - Updated with crypto and verified checkboxes
import React from 'react';

function BasicInfo({ data, onChange, slugEdited, onSlugEditToggle, onResetSlug }) {
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (name === "slug") {
      // Mark slug as manually edited
      onSlugEditToggle(true);
      // Generate slug-friendly value
      const slugValue = value
        .toLowerCase()
        .replace(/[^\w\s-]/g, '')  // Remove special characters
        .replace(/\s+/g, '-')      // Replace spaces with hyphens
        .replace(/--+/g, '-')      // Replace multiple hyphens with single hyphen
        .trim();                   // Trim whitespace
  
      onChange({ [name]: slugValue });
    } else {
      // Handle checkbox inputs differently
      const newValue = type === 'checkbox' ? checked : value;
      onChange({ [name]: newValue });
    }
  };
  
  return (
    <div className="space-y-4">
      <h4 className="text-lg font-medium text-gray-700">Basic Information</h4>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
            Brand Name *
          </label>
          <input
            id="name"
            name="name"
            type="text"
            required
            value={data.name}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
            placeholder="Enter brand name"
          />
        </div>

        <div>
          <label htmlFor="slug" className="block text-sm font-medium text-gray-700 mb-1">
            URL Slug *
            <span className="ml-1 text-xs text-gray-500">
              (used in URL: yoursite.com/{data.slug})
            </span>
          </label>
          <div className="flex gap-2">
            <input
              id="slug"
              name="slug"
              type="text"
              required
              value={data.slug}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
              placeholder="brand-name"
            />
            {slugEdited && (
              <button
                type="button"
                onClick={onResetSlug}
                className="bg-gray-100 text-gray-700 px-3 py-2 rounded-lg border border-gray-300 hover:bg-gray-200 text-sm"
              >
                Reset
              </button>
            )}
          </div>
          <p className="mt-1 text-xs text-gray-500">
            Auto-generated from the brand name. You can edit it if needed.
          </p>
        </div>
      </div>

      <div>
        <label htmlFor="websiteUrl" className="block text-sm font-medium text-gray-700 mb-1">
          Website URL
          <span className="ml-1 text-xs text-gray-500">
            (e.g. https://example.com)
          </span>
        </label>
        <input
          id="websiteUrl"
          name="websiteUrl"
          type="url"
          value={data.websiteUrl || ''}
          onChange={handleChange}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
          placeholder="https://example.com"
        />
        <p className="mt-1 text-xs text-gray-500">
          Enter the full URL including 'https://'
        </p>
      </div>
      
      <div>
        <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-1">
          Description *
        </label>
        <textarea
          id="description"
          name="description"
          rows="3"
          required
          value={data.description}
          onChange={handleChange}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
          placeholder="Describe the brand and what makes it special"
        />
      </div>
      
      <div>
        <label htmlFor="welcomeBonus" className="block text-sm font-medium text-gray-700 mb-1">
          Welcome Bonus *
        </label>
        <input
          id="welcomeBonus"
          name="welcomeBonus"
          type="text"
          required
          value={data.welcomeBonus}
          onChange={handleChange}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
          placeholder="e.g. 200% up to $500"
        />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Verified brand checkbox */}
        <div className="flex items-center">
          <input
            id="verified"
            name="verified"
            type="checkbox"
            checked={data.verified || false}
            onChange={handleChange}
            className="h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
          />
          <label htmlFor="verified" className="ml-2 block text-sm font-medium text-gray-700">
            Verified Brand
          </label>
        </div>

        {/* Crypto payments checkbox */}
        <div className="flex items-center">
          <input
            id="acceptsCrypto"
            name="acceptsCrypto"
            type="checkbox"
            checked={data.acceptsCrypto || false}
            onChange={handleChange}
            className="h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
          />
          <label htmlFor="acceptsCrypto" className="ml-2 block text-sm font-medium text-gray-700">
            Accepts Cryptocurrency
          </label>
        </div>
      </div>
      
      <div>
        <label htmlFor="rating" className="block text-sm font-medium text-gray-700 mb-1">
          Rating (1-5)
        </label>
        <div className="flex items-center">
          <input
            id="rating"
            name="rating"
            type="range"
            min="1"
            max="5"
            step="0.1"
            value={data.rating}
            onChange={handleChange}
            className="w-full mr-4"
          />
          <span className="text-lg font-semibold text-blue-600 min-w-[3rem] text-center">
            {data.rating}
          </span>
        </div>
      </div>
    </div>
  );
}

export default BasicInfo;